import React, { useRef, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import useOutsideClick from '../../../../hooks/useOutsideClick';

import ChevronIcon from '../../../../assets/images/icons/chevron.svg';
import './CustomSelect.scss';

const CustomSelect = ({ label, options, selectedOption, setSelectedOption, isPagination }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectRef = useRef(null);
  const selectInput = useRef(null);

  const handleOptionSelect = (value) => {
    setSelectedOption(value);
    setIsOpen(false);
  };

  useOutsideClick(selectRef, selectInput, isOpen, () => setIsOpen(false));

  return (
    <div className={`custom-select ${isOpen ? 'opened' : ''} ${isPagination ? 'pagination' : ''}`} ref={selectRef}>
      <span className="input__label">{label}</span>
      <div ref={selectInput} className="selected-option" onClick={() => setIsOpen(!isOpen)}>
        <span className={`selected-option__name ${selectedOption === 'Social Services' && 'blue'}`}>
          {selectedOption ? options.find((option) => option.value == selectedOption).label : ''}
        </span>
        <div className="arrow-wrapper">
          <img src={ChevronIcon} className={`arrow ${isOpen ? 'rotated' : ''}`} />
        </div>
      </div>
      {isOpen && (
        <div className={`options-wrapper n${options.length}`}>
          {options.length === 0 ? (
            <span className="no-data">No data</span>
          ) : (
            <PerfectScrollbar
              options={{
                wheelPropagation: false,
                autoHide: false,
              }}
            >
              <ul className="options-list">
                {options.map((option, index) => (
                  <li
                    key={index}
                    className={option.label === 'Social Services' ? 'blue' : ''}
                    onClick={() => handleOptionSelect(option.value)}
                  >
                    {option.label}
                  </li>
                ))}
              </ul>
            </PerfectScrollbar>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
